<template>
  <div>
    <div class="nav-box">
      <div class="item" :class="{active:nav == 'diy'}" @click="selectNav('diy')">我的定制</div>
      <div class="item" :class="{active:nav == 0}" @click="selectNav(0)">热卖推荐</div>
      <div class="item" :class="{active:nav == 1}" @click="selectNav(1)">所有商品</div>
      <div class="item" :class="{active:nav == 2}" @click="selectNav(2)">拍卖商品</div>
      <div class="item" :class="{active:nav == 3}" @click="selectNav(3)">团购商品</div>

      <div class="item" title="点击可复制" @click="$helper.copyText('https://www.aiviy.com?pid=' + $store.state.authInfo.id)">*全站推广：https://www.aiviy.com?pid={{$store.state.authInfo.id}} <a-icon type="copy"></a-icon></div>
    </div>
    <div class="search-box" v-if="nav == 1">
      <div class="left">
        佣金比例：<a-input style="width:100px;" class="ghost" addon-after="%" v-model="filter.commission[0]"></a-input> ~ <a-input style="width:100px;"  class="ghost" addon-after="%" v-model="filter.commission[1]"></a-input>
      </div>
      <div class="right">
        <a-input style="width:200px; margin-right:10px" class="ghost" placeholder="输入商品名称" v-model="filter.name"></a-input>
        <a-button shape="round" type="primary" @click="search">搜索</a-button>
      </div>
    </div>
    <!-- 商品列表 -->
    <template v-if="nav != 2">
    <div class="products-box">
      <div class="product-item" v-for="item in products.data" :key='item.id'>
        <i class="rec-icon" v-if="item.is_rec &&  nav != 3 && nav != 'diy'">
          <a-icon type="star" theme='filled'></a-icon>
        </i>
        <i class="rec-icon" v-if="nav == 3">
          <a-icon type="usergroup-add" />
        </i>
        <i class="rec-icon" v-if="nav == 'diy'">
          <a-icon type="highlight" />
        </i>
        
        <img :src="$store.state.assetUrl + item.img" alt="">
        <a :href="'/item/' + item.slug" target="_blank" class="name text-ellipsis-2">{{item.name}}</a>
        <div class="bill-box">
          <div class="item">
            <div class="label">售价</div>
            <div class="value"><span>￥</span>{{item.sku_info.price}}</div>
          </div>
          <div class="item">
            <div class="label">佣金比例</div>
            <div class="value">{{item.sku_info.commission_rate}}<span>%</span></div>
          </div>
          <div class="item">
            <div class="label">预计佣金</div>
            <div class="value commission"><span>￥</span>{{item.sku_info.commission}}</div>
          </div>
          <div class="item">
            <div class="label">专属优惠 
              <a-tooltip  overlay-class-name="white">
                  <template slot="title">
                    <div style="font-size:12px">
                    用户点击您的推广链接进入商城购买下单时自动享受该优惠！
                    </div>
                  </template>
                  <a-icon type="question-circle"></a-icon>
              </a-tooltip>
            </div>
            <div class="value discount">-<span>￥</span>{{item.sku_info.exclusive_discount}}</div>
          </div>
        </div>
        <div class="to-share-box">
          <a @click="showLinkModal(item.id)">
            我要推广 <a-icon type="share-alt"></a-icon>
          </a>
          <a @click="showMediaModal(item.id)">
            生成素材 <a-icon type="download"></a-icon>
          </a>
        </div>
      </div>
    </div>
    <div class="page-box"  v-if="nav == 1">
       <a-pagination :total="products.total" v-model="filter.page" @change="getProducts" :page-size="20" />
    </div>
    </template>
    <!-- 拍卖商品列表 -->
    <template v-if="nav == 2">
    <div class="products-box">
      <div class="product-item" v-for="item in auctions" :key='item.id'>
        <i class="rec-icon">
          <a-icon type="fire" theme='filled'></a-icon>
        </i>
        <img :src="$store.state.assetUrl + item.product.img" alt="">
        <a :href="'/auction/' + item.id" target="_blank" class="name text-ellipsis-2">{{item.product.name}}</a>
        <div class="bill-box">
          <div class="item">
            <div class="label">佣金比例</div>
            <div class="value">{{item.sku_info.commission_rate}}<span>%</span></div>
          </div>
        </div>
        <div class="to-share-box  auction-btns">
          <a @click="showAuctionLinkModal(item.id)">
            我要推广 <a-icon type="share-alt"></a-icon>
          </a>
        </div>
      </div>
    </div>
    </template>

    <a-modal v-model="linkVisible" title="获取推广链接" width="800px" :footer="null" :maskStyle="{background:'rgba(0,0,0,0.03)'}" centered destroyOnClose>
      <template  slot="closeIcon">
        <a-icon type="close-circle" theme="filled"/>
      </template>
      <div class="white-wrap">
        <div class="info-box">
          <div class="img">
            <img :src="$store.state.assetUrl + product.img" alt="">
          </div>
          <div class="info">
            <div class="name">{{product.name}}</div>
            <div class="desc">{{product.desc}}</div>
            <div class="color-danger" v-if='nav == 3'>用户以团购价购买时不会享受专属优惠</div>
          </div>
        </div>
        <div class="skus-box">
          <div class="sku-item head">
            <div class="spec">规格</div>
            <div class="price">售价</div>
            <div class="rate">佣金比例</div>
            <div class="">预计佣金</div>
            <div class="">专属优惠</div>
          </div>
          <div class="sku-item" v-for="item in product.skus" :key="item.id">
            <div class="spec">{{item.spec_desc}}</div>
            <div class="price">
              {{item.price}}
              <div v-if='nav == 3'>(团购价：{{item.groupon_price}})</div>
            </div>
            <div class="rate">{{item.commission_rate}}%</div>
            <div class="commission">{{item.commission}}</div>
            <div class="discount">{{item.exclusive_discount}}</div>
          </div>
        </div>
        
        <div>
          <a-form-item label="推广位">
                <a-select v-model="ap" dropdown-class-name="durk" class="ract-item w100p" @change="showLinkModal(product.id)">
                  <a-select-option :value="0">无</a-select-option>
                  <a-select-option v-for="item in aps" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
          <div class="link-box">
            <div class="item long">
              <div class="value" @click="$helper.copyText(product.long_link)">{{product.long_link}}</div>
              <div class="label">长推广链接，点击可复制</div>
            </div>
            <div class="item sort" v-for="(link,index) in product.sort_links" :key="index">
              <div class="value" @click="$helper.copyText(link)">{{link}}</div>
              <div class="label">短推广链接，点击可复制</div>
            </div>
          </div>
          <div class="review-title">推广海报</div>
          <a-row :gutter="12">
            <a-col :span="11">
              <a-form-item label="显示名称"><a-input class="ract-item" v-model="postInfo.name"></a-input></a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="显示价格"><a-input-number class="ract-item w100p" v-model="postInfo.price"></a-input-number></a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="优惠文字"><a-input class="ract-item w100p" v-model="postInfo.promote"></a-input></a-form-item>
            </a-col>
            <a-col :span="3">
              <a-form-item label="操作"><a-button type="primary" @click="recreatePost">更新海报</a-button></a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="text-center">
          <share-post v-model="postInfo"></share-post>
        </div>
      </div>  
    </a-modal>

    <a-modal v-model="auctionLinkVisible" title="获取拍卖推广链接" width="800px" :footer="null" :maskStyle="{background:'rgba(0,0,0,0.03)'}" centered destroyOnClose>
      <template  slot="closeIcon">
        <a-icon type="close-circle" theme="filled"/>
      </template>
      <div class="white-wrap">
        <div class="info-box">
          <div class="img">
            <img :src="$store.state.assetUrl + auction.product.img" alt="">
          </div>
          <div class="info">
            <div class="name">{{auction.product.name}}</div>
            <div class="desc">{{auction.product.desc}}</div>
          </div>
        </div>
        <div class="skus-box">
          <div class="sku-item head">
            <div class="spec">规格</div>
            <div class="rate">佣金比例</div>
          </div>
          <div class="sku-item" >
            <div class="spec">{{auction.sku_info.spec_desc}}</div>
            <div class="rate">{{auction.sku_info.commission_rate}}%</div>
          </div>
        </div>
        
        <div>
          <a-form-item label="推广位">
            <a-select v-model="ap" dropdown-class-name="durk" class="ract-item w100p" @change="showAuctionLinkModal(auction.id)">
              <a-select-option :value="0">无</a-select-option>
              <a-select-option v-for="item in aps" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <div class="link-box">
            <div class="item long">
              <div class="value" @click="$helper.copyText(auction.long_link)">{{auction.long_link}}</div>
              <div class="label">长推广链接，点击可复制</div>
            </div>
            <div class="item sort" v-for="(link, index) in auction.sort_links" :key="index">
              <div class="value" @click="$helper.copyText(link)">{{link}}</div>
              <div class="label">短推广链接，点击可复制</div>
            </div>
          </div>
          <div class="review-title">推广海报</div>
          <a-row :gutter="12">
            <a-col :span="11">
              <a-form-item label="显示名称"><a-input class="ract-item" v-model="postInfo.name"></a-input></a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="显示价格"><a-input-number class="ract-item w100p" v-model="postInfo.price"></a-input-number></a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="优惠文字"><a-input class="ract-item w100p" v-model="postInfo.promote"></a-input></a-form-item>
            </a-col>
            <a-col :span="3">
              <a-form-item label="操作"><a-button type="primary" @click="recreatePost">更新海报</a-button></a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="text-center">
          <share-post v-model="postInfo"></share-post>
        </div>
      </div>  
    </a-modal>

    <a-modal v-model="mediaVisible" title="生成素材" width="640px" :footer="null" :maskStyle="{background:'rgba(0,0,0,0.03)'}" centered>
      <template  slot="closeIcon">
        <a-icon type="close-circle" theme="filled"/>
      </template>
      <div class="white-wrap">
        <div class="media-info-box">
          <div class="img">
            <img :src="$store.state.assetUrl + mediaInfo.img" alt="">
          </div>
                    
        </div>
        <div class="media-creater">
          <a-row :gutter="12">
            <a-col :span="6">
              <a-form-item label="显示LOGO"><a-input class="ract-item" v-model="mediaInfo.title"></a-input></a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="显示价格"><a-input-number class="ract-item w100p" v-model="mediaInfo.price"></a-input-number></a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="尺寸类型">
                <a-select v-model="mediaInfo.size" class="ract-item w100p"  dropdown-class-name="durk" @change="distVisible = false">
                  <a-select-option :value="0">正方型</a-select-option>
                  <a-select-option :value="1">长方型</a-select-option>
                  <a-select-option :value="2">迷你型</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="背景颜色">
                <a-select v-model="mediaInfo.color" class="ract-item w100p"  dropdown-class-name="durk">
                  <a-select-option value="red">红色</a-select-option>
                  <a-select-option value="blue">蓝色</a-select-option>
                  <a-select-option value="green">绿色</a-select-option>
                  <a-select-option value="yellow-green">黄绿色</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
               <a-form-item label="显示名称"><a-input class="ract-item" v-model="mediaInfo.name"></a-input></a-form-item>
            </a-col>
          </a-row>
          <div class="review-title">
              预览
          </div>
          <div class="review-box" :class="mediaInfo.color">
            
            <div class="content review-content" v-if="mediaInfo.size == 0"  ref="review">
              <img :src="$store.state.assetUrl + mediaInfo.img" alt="">
              <div class="title text-center">{{mediaInfo.title}}</div>
              <div class="bottom">
                <div class="name">{{mediaInfo.name}}</div>
                <div class="text-center">
                  <span class="btn">优惠价 <span class="small">￥</span>{{mediaInfo.price}}</span>
                </div>
              </div>
            </div>
            <div class="content-1  review-content" v-if="mediaInfo.size == 1"  ref="review">
              <div class="left">
                  <div class="title">{{mediaInfo.title}}</div>
                  <div class="name">{{mediaInfo.name}}</div>
                  <div class="">
                    <span class="btn">优惠价 <span class="small">￥</span>{{mediaInfo.price}}</span>
                  </div>
              </div>
              <div class="right"><img :src="$store.state.assetUrl + mediaInfo.img" alt=""></div>
            </div>
            <div class="content-2  review-content" v-if="mediaInfo.size == 2"  ref="review">
              <div class="left"><img :src="$store.state.assetUrl + mediaInfo.img" alt=""></div>
              <div class="right">
                  <div class="title">{{mediaInfo.title}}</div>
                  <div class="name">{{mediaInfo.name}}</div>
              </div>
            </div>
          </div>
          <div class="mt-1 text-center">
            <a-button type="danger" @click="buildImg">生成图片</a-button>
            <div><a-icon type="arrow-down"></a-icon></div>
          </div>
          <div class="dis-box" v-if="distVisible" :class="'r-'+mediaInfo.size">
            <img :src="mediaInfo.distImg" alt="">
            <div>鼠标右键选择保存图片</div>
          </div>
        </div>
      </div>  
    </a-modal>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import sharePost from "../components/sharePost.vue"
let self;
export default {
  name: '',
  components:{sharePost},
  data(){
    return {
      nav:0,
      products:{},
      filter:{
        name:'',
        commission:[],
        page:1,
      },
      mediaInfo:{
      },
      mediaVisible:false,
      linkVisible:false,
      auctionLinkVisible:false,
      auction:{
        product:{},
        sku_info:{}
      },
      product:{},
      auctions:[],
      distVisible:false,
      postImg:'',
      postVisible:false,
      qrcode_bg:'',
      qrcode_bg_groupon:'',
      qrcode_bg_auction:'',
      aps:[],
      ap:0,
      postInfo:{
        price:0,
        name:""
      },
    }
  },
  mounted(){
    self = this;
    this.nav = this.$route.query.nav || 0;
    this.getProducts();
    this.getQrcodeMediaBg();
    this.getAps();
  },
  methods:{
    getAps(){
      this.$http.get("getAps").then((res)=>{
        self.aps = res.data;
      });
    },
    getProducts(){
      let params = this.filter;
      if(this.nav == 0){
        params.type = 'rec';
      }
      if(this.nav == 3){
        params.type = 'groupon';
      }
      if(this.nav == 1){
        params.type = 'all';
      }

      if(this.nav == 'diy'){
        params.type = 'diy';
      }

      this.$http.get('listProducts',{params}).then((res)=>{
        self.products = res.data;
      })
    },
    search(){
      this.filter.page = 1;
      this.getProducts();
    },
    selectNav(nav){
      this.nav = nav;
      this.page = 1;
      if(nav == 2){
        this.getAuctions();
      }else{
        this.getProducts();
      }
      
    },
    getQrcodeMediaBg(){
      this.$http.get('getQrcodeMediaBg').then((res)=>{
        self.qrcode_bg = res.data.qrcode_bg.img;
        self.qrcode_bg_groupon = res.data.qrcode_bg_groupon.img;
        self.qrcode_bg_auction = res.data.qrcode_bg_auction.img;
      })
    },
    recreatePost(){
      this.postInfo = {...this.postInfo}
    },
    showLinkModal(id){
      this.linkVisible = true;
      this.postVisible =false;
      this.$http.get('getProduct',{params:{id:id, ap:this.ap}}).then((res)=>{
        let info = res.data;
        self.product = info;
        this.postInfo = {
          img: info.img,
          name: info.name,
          tags: info.tags,
          promote: "特价优惠中",
          link: info.long_link,
          qrcode_url: info.qrcode_url,
          price:0,
        }
        let sku = info.skus[info.skus.length - 1];
        if(self.nav == 3){
          this.postInfo.price = sku.groupon_price;
        }else{
          this.postInfo.price = (parseInt(sku.price*100) - parseInt(sku.exclusive_discount*100)) / 100;
        }
        
      })
    },
    getAuctions(){
      this.$http.get('listAuctions').then((res)=>{
        self.auctions = res.data;
      })
    },
    showAuctionLinkModal(id){
      this.auctionLinkVisible = true;
      this.postVisible =false;

      this.$http.get('getAuction',{params:{id:id, ap:this.ap}}).then((res)=>{
        let record = res.data;
        this.auction = {...record}

        this.postInfo = {
          img: record.product.img,
          name: record.product.name,
          tags: record.product.tags,
          promote: "特价优惠中",
          link: record.long_link,
          qrcode_url: record.qrcode_url,
          price: record.start_price,
        }
      })
    },
    showMediaModal(id){
      this.$http.get('getProduct',{params:{id:id}}).then((res)=>{
        let info = res.data;
        let sku = info.skus[info.skus.length - 1];
        info.price = (parseInt(sku.price*100) - parseInt(sku.exclusive_discount*100)) / 100;
        self.mediaInfo = {...info,size:0,color:'red',title:'Aiviy',distImg:''};
      })
      self.distVisible = false;
      this.mediaVisible = true;
    },
    buildImg() {
      let canvas = document.createElement('canvas') // 创建一个canvas节点
      let scale = 2 // 定义任意放大倍数 支持小数
      let elem = document.getElementsByClassName('review-content')[0]
      canvas.width = elem.clientWidth * scale // 定义canvas 宽度 * 缩放
      canvas.height = elem.clientHeight * scale // 定义canvas高度 *缩放
      canvas.getContext('2d').scale(scale, scale) // 获取context,设置scale

      html2canvas(this.$refs.review, {
        scale:1,
        canvas,
        dpi:300,
        useCORS:true,
        allowTaint:true,
        }).then((canvas) => {
        let imageUrl = canvas.toDataURL('image/png'); // 将canvas转成base64图片格式
        self.mediaInfo.distImg = imageUrl;
        self.distVisible = true;
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../assets/reset.less';
.nav-box{
  display: flex;
  margin-bottom: 40px;
}
.nav-box .item{
  position: relative;
  padding-right: 60px;
  cursor: pointer;
}
.nav-box .item:hover{
  color: rgba(255, 255, 255, 0.8);
}
.nav-box .item.active{
  color: #fff;
}
.nav-box .item.active::after{
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 30px;
  height: 2px;
  background: #fff;
}

.search-box{
  background: rgba(255, 255, 255, 0.04);
  padding: 1rem;
  border-radius: 5px;
  display: flex;
}
.search-box .left{
  flex: 1;
}
.search-box .right{
  flex: 1;
  text-align: right;
}
.products-box{
  margin-right: -20px;
  margin-top: 30px;
}
.product-item{
  display: inline-block;
  background: #222338;
  box-shadow: 0 0 0 1px rgba(255,255,255,0.1);
  padding: 1rem;
  border-radius: 5px;
  width: calc(25% - 20px);
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}
.product-item .rec-icon{
  position: absolute;
  right: 7px;
  top: 7px;
  color: @primary-color;
}
.product-item:hover{
  box-shadow: 0 0 0 1px rgba(255,255,255,0.1),0 0 10px rgba(255,255,255,0.1);
}
.product-item .name{
  height: 43px;
  font-size: 15px;
   color: rgba(255, 255, 255, 0.7);
}
.product-item img{
  width: 60px;
  margin-bottom: 30px;
}
.product-item .bill-box{
  color: rgba(255, 255, 255, 0.6);
  border-top: 1px dashed rgba(255, 255, 255, 0.1);
  margin-top: 10px;
  padding-top: 10px;
}
.product-item .bill-box .item{
  display: flex;
  width: 100%;
  padding: 5px 0;
  font-size: 12px;
}
.product-item .bill-box .item .label{
  flex: 1;
}
.product-item .bill-box .item .value{
  flex: 2;
  color: #fff;
  font-family: cursive;
  text-align: right;
  font-size: 14px;
}
.product-item .bill-box .item .value.commission{
  color: @error-color;
}
.product-item .bill-box .item .value.discount{
  color: @primary-color;
}

.to-share-box{
  color: #fff;
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px dashed rgba(255, 255, 255, 0.1);
  display: flex;
}
.to-share-box a:first-child{
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}
.to-share-box.auction-btns a:first-child{
  border-right: none;
}
.to-share-box a{
  flex: 1;
  text-align: center;
  font-size: 12px;
}
.page-box{
  margin-top: 20px;
  text-align: right;
}


.info-box{
  margin-bottom: 20px;
  display: flex;
}
.info-box .img{
  text-align: center;
  margin-right: 10px;
  flex: 1;
  height: auto;
}
.info-box .info{
  flex: 5;
}
.info-box .img img{
  width: 80px;
  height: 80px;
}
.info-box .name {
  font-size: 16px;
  color: #111;
  margin-bottom: 10px;
}
.info-box .desc{
  font-size: 12px;
}

.skus-box .sku-item{
  display: flex;
  font-size: 12px;
}
.skus-box .sku-item .spec{
  flex: 2;
}
.skus-box .sku-item>div{
  flex: 1;
  text-align: center;
}
.skus-box .sku-item{
  padding:1rem 0;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
}
.skus-box .sku-item.head{
  background: rgba(0, 0, 0, 0.05);
}
.skus-box .sku-item .commission{
  font-weight: 500;
  color: @error-color;
  font-size: 14px;
}
.skus-box .sku-item:last-child{
  border-bottom: none;
}

.link-box{
  margin-top: 20px;
}
.link-box .item{
  
  
  text-align: center;
  margin-bottom: 20px;
}
.link-box .item .value{
  background: rgba(0, 0, 0, 0.05);
  padding: 8px;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.2s ;
}
.link-box .item .value:active{
  opacity: 0.8;
}
.link-box .item .label{
  font-size: 12px;
}
.link-box .item.long .value{
  background: @info-color;
  color: #fff;
}
.link-box .item.sort .value{
  background: @success-color;
  color: #fff;
}

.media-info-box{
  text-align: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
.media-info-box img{
  height: 60px;
}
.review-title{
  border-top:  1px dashed rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
  text-align: center;
  padding-top: 1rem;
  margin-bottom: 1rem;
  font-size: 18px;
  font-weight: bold;
}
.review-box{
  
  
}
.review-box .content{
  height: 250px;
  width: 250px;
  position: relative;
  background: rgba(0, 0, 0, 0.05);
  margin: 0 auto;
  padding: 1rem;
}
.review-box.red .content, .review-box.red .content-1, .review-box.red .content-2{
  background: linear-gradient(180deg, rgba(230, 57, 70, 0.8), rgba(230, 57, 70, 1));
  color: #fff;
}
.review-box.blue .content, .review-box.blue .content-1, .review-box.blue .content-2{
  background: linear-gradient(180deg,  #6794CD, #356199,);
  color: #fff;
}
.review-box.green .content, .review-box.green .content-1, .review-box.green .content-2{
  background: linear-gradient(180deg, rgba(67, 170, 139, 0.8), rgba(67, 170, 139, 1));
  color: #fff;
}
.review-box.yellow-green .content, .review-box.yellow-green .content-1, .review-box.yellow-green .content-2{
  background: linear-gradient(45deg, #dae250, #1af5e0);
  color: #fff;
}
.review-box .content img{
  height: 90px;
  display: block;
  margin: 10px auto;
}
.review-box .content .bottom{
  width: 100%;
  padding-bottom: 1rem;
  text-align: center;
}

.review-box .content .title{
  font-weight: 500;
  font-size: 18px;
  font-family: fantasy;
}
.review-box .btn{
  display: inline-block;
  vertical-align: middle;
  padding: 0 12px;
  height: 26px;
  line-height: 20px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  margin-top: 14px;
}

.review-box .content-1{
  height: 200px;
  width: 600px;
  display: flex;
}

.review-box .content-1{
  padding: 40px;
}
.review-box .content-1 .title{
  font-size: 26px;
  font-weight: 500;
  font-family: fantasy;
}
.review-box .content-1 .left{
  flex: 2;
  text-align: center;
}
.review-box .content-1 .right{
  flex: 1;
  text-align: right;
  padding-right: 30px;

}
.review-box img{
  height: 100%;
}

.review-box .content-2{
  height: 60px;
  width: 240px;
  display: flex;
  margin: 0 auto;
}

.review-box .content-2 .title{
  font-size: 16px;
  font-weight: 500;
  font-family: fantasy;
  line-height: 18px;
}
.review-box .content-2 .name{
  line-height: 14px;
}
.review-box .content-2 .left{
  flex: 1;
  padding: 10px;
}
.review-box .content-2 .right{
  flex: 4;
  font-size: 12px;
  padding: 5px;
}

.review-box img{
  height: 100%;
}
.dis-box{
  margin: 1rem 0;
  text-align: center;
}
.dis-box img{
  max-width: 100%;
}
.dis-box.r-0 img{
  height: 250px;
}
.dis-box.r-1 img{
  height: 200px;
}
.dis-box.r-2 img{
  height: 60px;
}


.qrcode-box{
  position: relative;
}
.qrcode-box{
  height: 300px;
  width: 750px;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: 20px;
}
.qrcode-box .desc{
  position: absolute;
  top: 40px;
  left: 280px;
  width: 250px;
}
.qrcode-box .name{
  position: absolute;
  font-size: 16px;
  font-weight: 500;
  width: 210px;
  color: #111;
  left: 30px;
  text-align: center;
  top: 200px;
}
.qrcode-box .img{
  position: absolute;
  height: 150px;
  width: 150px;
  left: 60px;
  top: 40px;
}
.qrcode-box .qrcode{
  position: absolute;
  right: 28px;
  top: 40px;
  height: 140px;
  width: 140px;
}
.qrcode-box .price{
  font-size: 22px;
  font-weight: 500;
  color: #356199;
  position: absolute;
  right: 28px;
  bottom: 80px;
  width: 140px;
  text-align: center;
}
.qrcode-box .copy-tips{
  position: absolute;
  right: 28px;
  bottom: 60px;
  width: 140px;
  text-align: center;
}
.qrcode-box .rate{
  position: absolute;
  bottom: 75px;
  left: 280px;
  width: 250px;
  text-align: center;
}
.qrcode-box .rate img{
  height: 30px;
}
</style>
